import { useCallback, useEffect, useState } from 'react'
import { AutomaticSummarizationContext } from '../contexts/AutomaticSummarizationContext'
import { useSelector } from 'react-redux'
import api from '../services/api'

export const AutomaticSummarizationProvider = ({ children }) => {
  const [
    isAutomaticallyGenerateSummaryEnabled,
    setIsAutomaticallyGenerateSummaryEnabled,
  ] = useState(false)
  const [firstTime, setFirstTime] = useState(true)
  const [isLoading, setIsLoading] = useState(true)
  const user = useSelector((state) => state.user)

  const handleUpdate = useCallback(async (value, updateActualValue = true) => {
    setIsLoading(true)
    await api({
      method: 'put',
      url: '/user/metadata',
      data: {
        key: 'is_automatically_generate_summary_enabled',
        value: value.toString(),
      },
    })
      .then(() => {
        if (updateActualValue) {
          setIsAutomaticallyGenerateSummaryEnabled(value)
          setFirstTime(false)
        }
      })
      .finally(() => setIsLoading(false))
  }, [])

  const handleGetValue = useCallback(
    async ({ isAutomaticSummarizationEnabled = true }) => {
      if (!isAutomaticSummarizationEnabled) return setIsLoading(false)

      await api({
        method: 'get',
        url: '/user/metadata?key=is_automatically_generate_summary_enabled',
      })
        .then((response) =>
          setIsAutomaticallyGenerateSummaryEnabled(
            response.data.data.value === 'true'
          )
        )
        .catch(() => handleUpdate(true, false))
        .finally(() => setIsLoading(false))
    },
    [handleUpdate]
  )

  const handleCheckIfValueExists = useCallback(async () => {
    const response = await api({
      method: 'get',
      url: '/user/metadata?key=is_automatically_generate_summary_enabled',
    })
    if (response.status === 404) setFirstTime(true)
    else setFirstTime(false)
  }, [])

  useEffect(() => {
    if (!Object.keys(user ?? {}).length) return
    handleCheckIfValueExists()
  }, [handleCheckIfValueExists, user])

  return (
    <AutomaticSummarizationContext.Provider
      value={{
        isAutomaticallyGenerateSummaryEnabled,
        save: handleUpdate,
        refresh: handleGetValue,
        firstTime,
        isLoading,
      }}
    >
      {children}
    </AutomaticSummarizationContext.Provider>
  )
}
